/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type AccountNav_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_viewer">;
    readonly " $refType": "AccountNav_viewer";
};
export type AccountNav_viewer$data = AccountNav_viewer;
export type AccountNav_viewer$key = {
    readonly " $data"?: AccountNav_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isClient"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountNav_viewer",
    "selections": [
        {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "Defer",
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AccountNavContent_viewer"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '455a7ca665ae3fdc818a7437bf790b32';
export default node;
